import { LoaderFunction } from "react-router-dom";
import { getCollabCampaignById } from "services/SauceService";

export const campaignLoader: LoaderFunction = async (props: any) => {
  const collab: any = await getCollabCampaignById(props.params.id);

  return collab;
};
